import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getGAMeasurementId } from "../../utils/gaConfig";

const GoogleAnalyticsTracker = () => {
  const location = useLocation();
  const measurementId = getGAMeasurementId();

  useEffect(() => {
    // Load Google Analytics gtag.js script with environment-specific measurement ID
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    // Initialize gtag function and configure GA
    const script2 = document.createElement("script");
    const userId = sessionStorage.getItem("user_id"); // get user_id
    const sessionId = sessionStorage.getItem("session_id"); // get session_id

    // custom properties (you can add up to 10)
    const customProps = {
      custom_user_id: userId || "",
      // ... add up to 10 properties
    };

    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
  
      // Basic config with environment-specific measurement ID
      gtag('config', '${measurementId}');
  
      // If we have a user_id, set it explicitly
      ${userId ? `gtag('set', { user_id: '${userId}' });` : ""}
  
      // If we have a user_id, also set custom user_properties
      ${
        userId
          ? `gtag('set', 'user_properties', ${JSON.stringify(customProps)});`
          : ""
      }
  
     const initialPath = window.location.pathname + window.location.search + window.location.hash;
     console.log(initialPath, "initial path");
gtag('event', 'page_view', {
  page_location: window.location.href,
  page_path: initialPath,
  page_title: document.title,
  session_id: '${sessionId || ""}'
});
      

    `;
    document.head.appendChild(script2);

    // Cleanup function to remove scripts when component unmounts
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, [measurementId]);

  useEffect(() => {
    // Track page views on route changes (only after initial load)
    if (window.gtag && location.pathname !== "/") {
      const sessionId = sessionStorage.getItem("session_id");
      const currentPath = location.pathname + location.search + location.hash;
      console.log(currentPath, "path changed");

       // Update GA config so Realtime shows the correct page path
    window.gtag("config", measurementId, {
      page_path: currentPath,
      page_location: window.location.href,
      page_title: document.title,
    });

      // Fire page_view event with session_id (same as original landing page)
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: currentPath,
        page_title: document.title,
        session_id: sessionId || "",
      });
    }
  }, [location, measurementId]);

  return null; // This component doesn't render anything
};

export default GoogleAnalyticsTracker;
